module["exports"] = ["Dhr.", "Mevr. Dr.", "Bsc", "Msc", "Prof."];